import {
  inv01_2026,
  inv02_2026,
  inv03_2026,
  // inv04_2025,
  // inv05_2025,
  // inv06_2025,
  // inv07_2025,
  // inv08_2025,
  // inv_itp_01,
  // inv09_2025,
  // inv10_2025,
  // inv11_2025,
  // inv12_2025,
  // inv13_2025,
  // inv14_2025,
  // inv15_2025,
  // inv16_2025,
  // inv17_2025,
  // inv18_2025,
  // inv19_2025,
  // inv20_2025,
  // inv21_2025,
  // inv22_2025,
  // inv23_2025,
  // inv_itp_02,
} from "../../json/anioInvitaciones/2026/anioInvitacion2026";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CAASIM-HGO-INV3-OP-01-2026":
      datosSeleccionados = inv01_2026;
      break;
    case "CAASIM-HGO-INV3-OP-02-2026":
      datosSeleccionados = inv02_2026;
      break;
    case "CAASIM-HGO-INV3-OP-03-2026":
      datosSeleccionados = inv03_2026;
      break;

    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
